import { GenericStencil } from "@brexhq/metal-generic-stencil";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";

import { Nav, NavItemList } from "./";

export const DesktopNavLoadingStencil = ({ LogoSlot }) => (
  <Nav>
    <Container direction={"row"} gap={"sml"} alignItems={"center"}>
      <NavItemList>{LogoSlot}</NavItemList>
      <Container direction={"row"} gap={"sml"}>
        <GenericStencil width={100} height={20} />
        <GenericStencil width={100} height={20} />
        <GenericStencil width={100} height={20} />
        <GenericStencil width={100} height={20} />
      </Container>
    </Container>
    <Container direction={"row"} gap={"sml"} alignItems={"center"}>
      <GenericStencil width={100} height={20} />
      <GenericStencil width={140} height={35} />
    </Container>
  </Nav>
);
